var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-div',{staticClass:"BrowseGroups"},[_c('ContainerGrid',[(_vm.showDetails)?_c('LayoutItems',{attrs:{"items":_vm.groups,"component-name":_vm.componentName,"cols":"12","sm":"6","md":"4","lg":"4"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }